import { MI_RULES_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const miRulesSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MI_RULES_CRITERIA_ACTION_TYPE.GET_CRITERIA_SCHEMA:
      return payload || initialState;

    default:
      return state;
  }
};

export default miRulesSchemaReducer;
